import { render, staticRenderFns } from "./MyPasswordChange.vue?vue&type=template&id=74c7e08d&scoped=true&"
import script from "./MyPasswordChange.vue?vue&type=script&lang=js&"
export * from "./MyPasswordChange.vue?vue&type=script&lang=js&"
import style0 from "./MyPasswordChange.vue?vue&type=style&index=0&id=74c7e08d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c7e08d",
  null
  
)

export default component.exports